const projects = [
  {
    title: "What-you-tryna-watch",
    description:
      "A full stack web application built with latest programming languages and frameworks and allows users to search for movies and leave comments about these movies.",
    image: './what-you-tryna-watch.gif',
    repo: "https://github.com/bkhanal87/National-Parks",
    demo: "https://bkhanal87.github.io/National-Parks/",
  },
  {
    title: "National Parks",
    description:
      "This application was built to allow users to search for national parks in their desired U.S. State by the activity they want to do and see current weather conditions for that park",
    image: './national-parks.gif',
    repo: "https://github.com/bkhanal87/National-Parks",
    demo: "https://bkhanal87.github.io/National-Parks/",
  },
  {
    title: "Bank-application",
    description:
      "This is an application that allows clients to add users, update users, view the details of the added users, and delete users, if required",
    image: './bank-application-java.gif',
    repo: "https://github.com/bkhanal87/bank-app-frontend",
    demo: "https://bkhanal87.github.io/bank-app-frontend/users",
  },
];

export default projects;